var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"split-line-pc",style:({display: 'block', background: _vm.bgColor, height: _vm.height, width: '100%', marginTop: _vm.marginTop, marginBottom: _vm.marginBottom})})}
var staticRenderFns = []

export { render, staticRenderFns }